import React, { useState, useEffect } from 'react';
import axios from 'axios';
import eventEmitter from './eventEmitter';
import moment from 'moment';
import tono from '../tonos/tono.mp3'
export default function ButtonNot() {
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);

    let op = require('../modulos/datos');
    let token = localStorage.getItem('jwtToken');

    function playNotificationSound() {

        const audio = new Audio(tono);

        audio.play().catch(error => console.error('Error reproduciendo sonido:', error));
    }

    const seleccionarNotificaciones = () => {
        
        let endpoint = `${op.conexion}/api/configuracion/allnotificaciones`;

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then((response) => {
            if (response.status === 200) {
                setNotifications(response.data);
                setUnreadCount(response.data.length);
                if(response.data){
                    playNotificationSound()

                }
                
            }
        }).catch((error) => {
            console.error(error);
        });
    };
    const procesarNotificaciones = () => {
        
        let endpoint = `${op.conexion}/api/configuracion/noficacionupdate`;
        let body = {mensajes: notifications};
        
        setUnreadCount(0)
        axios.post(endpoint, body,{
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then((response) => {
            if (response.status === 200) {
               console.log(response)
            }
        }).catch((error) => {
            console.error(error);
        });
    };

    useEffect(() => {
        eventEmitter.on('updateNotifications', seleccionarNotificaciones);
        return () => {
            eventEmitter.off('updateNotifications', seleccionarNotificaciones);
        };
    }, []);

    useEffect(() => {
        seleccionarNotificaciones()
    }, []);

    return (
        <div className="dropdown">
            <button onClick={procesarNotificaciones} className="btn dropdown-toggle btn text-white" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i className="fas fa-bell"></i>
                {unreadCount > 0 && <span className="badge bg-danger ms-2">{unreadCount}</span>}
            </button>
            <ul className="dropdown-menu dropdown-menu-dark" style={{ maxHeight: '500px', overflow: 'auto', fontSize:'10px' }}>
                {notifications.length > 0 ? (
                    notifications.map((notification, index) => (
                        <li key={index}>
                            <div className="card" style={{ width: '22rem' }}>
                                <div className="card-body" style={{ position: 'relative' }}>
                                    <h5 className="card-title">{notification.tipo}</h5>
                                    <p className="card-text">{notification.mensaje + ' ' +'realizado por el usuario '+notification.login}</p>
                                    
                                    <label
                                        style={{
                                            position: 'absolute',
                                            bottom: '0',
                                            right: '0',
                                            margin: '10px' // Opcional: agrega margen si quieres algo de espacio alrededor
                                        }}
                                    >
                                        {moment.utc(notification.fecha).format('DD/MM/YYYY')}
                                    </label>
                                </div>
                                

                            </div>
                        </li>
                    ))
                ) : (
                    <li>No hay notificaciones</li>
                )}
            </ul>
        </div>
    );
}
